import { FileModel } from "../shared/file.model"

export class SearchManualModel{
    name:number = 0
}
export class SearchELiManualModel{
    pageNumber:number = 0
    criteria: ManualItemCriteriaModel[] = []
    pageSize:number = 0
    sort: ManualItemsortModel[] = []
}
export class ManualItemCriteriaModel {
    detail:string=''
    munalStart:string=''
    munalEnd:string=''
}
export class ManualItemsortModel {
    column:string=''
    direction:string=''
}
export class ManualItemModel{
    muId : number = 0
    muCode:number=0
    muDetail:string=''
    muUrl:string=''
    muTypefile:string=''
    muSize:string =''
    status:number = 0
    userName: string = null!
    updateDate:string =''

}

/*export class ManualItemModel{
    id : number = 0
    sequence:number=0
    name:string=''
    fileType:string=''
    downloadLink:string =''
}*/


export class ManualItemCUModel{
    id : number = 0
    sequence:number=0
    name:string='' //Detail
    downloadLink:string='' //URL
    fileType:string=''
    size:string=''
    userName: string = null!
}

export class ManualCuCreateGetUIModel{
    muCode:number=0
    muDetail:string=''
    muSize:string=''
    fileUp:string =''
    status:string=''
    Sstatus:boolean= false

}
export class ManualCuCreateModel{
    muCode:number=0
    muDetail:string=''
    muSize:string=''
    fileUp:string =''
    status:string=''

}

export class ManualMenuAuthModel{
    menuAuth:number=0
}

export class ManualFileUploadModel {
    file: FileModel = new FileModel
}

export class ManualCuUpdateModel{
    muId : number = 0
    muCode:number=0
    muDetail:string=''
    muUrl:string=''
    muSize:string=''
    muTypefile:string=''
    status:string=''
}

export class ManualCuUpdateUIModel{
    muId : number = 0
    muCode:number=0
    muDetail:string=''
    muUrl:string=''
    muSize:string=''
    muTypefile:string=''
    status:string=''
    Sstauus:boolean=false
}

export class ManualByIDModel{
    muId : number = 0

}

export class FileManualModel {
    file: FileModel = new FileModel
    item: FileManualItemModel = new FileManualItemModel
}

export class FileManualItemModel {
    notiSysId: number = 0
    docName: string = ''
}






